class Accordion {

	constructor(blockEl) {
		this.accordion = blockEl;
		this.itemHeaders = this.accordion.querySelectorAll('.accordion-container__header');

		this.itemHeaders.forEach((header) => {
			this.setExpanded(header, header.classList.contains('active'));
		});

		this.setEventHandlers();
	}

	setExpanded(header, isExpanded) {
		header.classList.toggle('active', isExpanded);
		header.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

		const panel = document.getElementById(header.getAttribute('aria-controls'));
		if (panel) {
			panel.inert = !isExpanded;
		}
	}

	setEventHandlers() {
		this.itemHeaders.forEach((accHeader) => {
			accHeader.addEventListener('click', () => {
				const isOpen = accHeader.classList.contains('active');

				this.itemHeaders.forEach((header) => {
					this.setExpanded(header, false);
				});

				if (!isOpen) {
					this.setExpanded(accHeader, true);
				}
			});
		});
	}
}

export default Accordion;
